var MessageSample = {

  get support() {
    let date = new Date();
    let hash = Utils.generateRandomToken(2);
    return {
      "conv_id": undefined,
      "created_at": date.toISOString(),
      "created_at_ts": date.getTime() / 1000,
      "from_description": null,
      "hash": hash,
      "id": hash,
      "image": _slaask._support_img,
      "keep_at_bottom": false,
      "mandatory_buttons": false,
      "name": _slaask._support_name,
      "parser": Message.PARSER.HTML,
      "plain_text": null,
      "status": 0,
      "text": "",
      "translated": false,
      "translate_reversed": false,
      "trigger_id": undefined,
      "type": "message",
      "user_id": 0
    }
  },

  get user() { return this.agent },
  get agent() {
    let date = new Date();
    let hash = Utils.generateRandomToken(2);
    return {
      "conv_id": undefined,
      "created_at": date.toISOString(),
      "created_at_ts": date.getTime() / 1000,
      "from_description": null,
      "hash": hash,
      "id": hash,
      "image": _slaask._support_img,
      "keep_at_bottom": false,
      "mandatory_buttons": false,
      "name": _slaask._support_name,
      "parser": Message.PARSER.MARKDOWN,
      "plain_text": null,
      "status": 0,
      "text": "",
      "translated": false,
      "translate_reversed": false,
      "trigger_id": undefined,
      "type": "message",
      "user_id": 0
    }
  },

  get guest() { return this.visitor },
  get contact() { return this.visitor },
  get visitor() {
    let date = new Date();
    let hash = Utils.generateRandomToken(2);
    return {
      "conv_id": undefined,
      "created_at": date.toISOString(),
      "created_at_ts": date.getTime() / 1000,
      "from_description": null,
      "hash": hash,
      "id": hash,
      "image": Utils.deepGet(_slaask._user_infos, ['more', 'avatar']),
      "keep_at_bottom": false,
      "mandatory_buttons": false,
      "name": "me",
      "parser": Message.PARSER.MARKDOWN,
      "plain_text": null,
      "status": 0,
      "text": "",
      "translated": false,
      "translate_reversed": false,
      "trigger_id": undefined,
      "type": "message",
      "user_id": 0
    }
  },

  get bot() {
    let date = new Date();
    let hash = Utils.generateRandomToken(2);
    return {
      "conv_id": undefined,
      "created_at": date.toISOString(),
      "created_at_ts": date.getTime() / 1000,
      "from_description": _slaask._bot_description,
      "hash": hash,
      "id": hash,
      "image": _slaask._bot_img,
      "keep_at_bottom": false,
      "mandatory_buttons": false,
      "name": _slaask._bot_name,
      "parser": Message.PARSER.HTML,
      "plain_text": null,
      "status": 0,
      "text": "",
      "translated": false,
      "translate_reversed": false,
      "trigger_id": undefined,
      "type": "message",
      "user_id": 0
    }
  },

  get typing() {
    let data = this.agent;
    data.parser = Message.PARSER.HTML;
    data.text = `
      <span class="slaask-dot slaask-dot1"></span>
      <span class="slaask-dot slaask-dot2"></span>
      <span class="slaask-dot slaask-dot3"></span>`;
    data.type = "typing";
    data.custom_class = "slaask-dots";
    data.keep_at_bottom = true;
    return data;
  }

};
var MS = MessageSample;
